import Joi from 'joi';
const frameSchema = Joi.object({
  type: Joi.string().valid('frame').required(),
  code: Joi.string().allow('', null).required(),
  frames: Joi.array().items(Joi.object({
    width: Joi.string().required(),
    content: Joi.string().allow('', null).required()
  }))
}).unknown(true);
export default frameSchema;